export const MEMBERS_APP_STORE_URL =
  'https://apps.apple.com/br/app/herospark-app-do-aluno/id1491015699'
export const MEMBERS_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.herospark'
